import css from '@styled-system/css'
import styled from 'styled-components'
import { Metadata } from 'ui/acro'

const SmallTextLink = styled(Metadata)(() =>
  css({
    textAlign: 'center',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0.308px',
    a: {
      textDecoration: 'underline'
    }
  })
)

export default SmallTextLink
